import { render } from "./TeamAdminTools.vue?vue&type=template&id=47151d3c"
import script from "./TeamAdminTools.vue?vue&type=script&lang=js"
export * from "./TeamAdminTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__